import { Link } from "react-router-dom";

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface Props {
    title: string;
}

export function CaseStudyBreadcrumb({
    title,
}: Props) {
    return (
        <Breadcrumb>

            <BreadcrumbList>

                <BreadcrumbItem>

                    <BreadcrumbLink asChild>

                        <Link to="/">
                            Home
                        </Link>

                    </BreadcrumbLink>

                </BreadcrumbItem>

                <BreadcrumbSeparator />

                <BreadcrumbItem>

                    <BreadcrumbLink asChild>

                        <Link to="/portfolio">
                            Portfolio
                        </Link>

                    </BreadcrumbLink>

                </BreadcrumbItem>

                <BreadcrumbSeparator />

                <BreadcrumbItem>

                    <BreadcrumbPage>

                        {title}

                    </BreadcrumbPage>

                </BreadcrumbItem>

            </BreadcrumbList>

        </Breadcrumb>
    );
}